'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _withBorder = require('./with-border');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_withBorder).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }